// Mock data for barebasics leather goods website

export const brand = {
  name: 'barebasics',
  tagline: 'The Art of Everyday Leather',
  established: 'Established 2018',
  description: 'Crafted for those who appreciate the honesty of natural materials, the patience of skilled hands, and objects that grow more beautiful with time.'
};

export const categories = [
  {
    id: 'bags',
    name: 'Bags',
    subtitle: 'Laptop bags & totes',
    tagline: 'Carry less, carry better.',
    intro: 'Structured portfolios and unhurried totes, cut from a single full-grain hide and stitched by hand. Made to hold a working day — and to look better for every one of them.',
    image: 'https://images.pexels.com/photos/27046146/pexels-photo-27046146.jpeg',
    count: 18
  },
  {
    id: 'desk',
    name: 'The Desk',
    subtitle: 'Mouse pads, coasters, tissue boxes',
    tagline: 'A quieter kind of workspace.',
    intro: 'Mouse pads, coasters and tissue box covers in vegetable-tanned leather. Small objects that bring warmth and order to the place where you think.',
    image: 'https://images.pexels.com/photos/28086429/pexels-photo-28086429.jpeg',
    count: 32
  },
  {
    id: 'small-leather',
    name: 'Small Leather Goods',
    subtitle: 'Wallets, belts, journals & keychains',
    tagline: 'The essentials, considered.',
    intro: 'Wallets, cardholders, belts, journals and keyrings — the pieces you touch a hundred times a day, made to be worth touching.',
    image: 'https://images.pexels.com/photos/4452393/pexels-photo-4452393.jpeg',
    count: 57
  },
  {
    id: 'gifting',
    name: 'Gifting',
    subtitle: 'Considered presents',
    tagline: 'A present that outlasts the occasion.',
    intro: 'Curated sets and gift-ready pieces, wrapped in a cotton dust bag. For the people who notice the stitching.',
    image: 'https://images.pexels.com/photos/33242820/pexels-photo-33242820.jpeg',
    count: 15
  }
];

export const products = [
  {
    id: 'p001',
    name: 'The Kavya Laptop Portfolio',
    category: 'bags',
    price: 12800,
    color: 'Cognac',
    image: 'https://images.pexels.com/photos/27046146/pexels-photo-27046146.jpeg',
    images: [
      'https://images.pexels.com/photos/27046146/pexels-photo-27046146.jpeg',
      'https://images.pexels.com/photos/28086429/pexels-photo-28086429.jpeg',
      'https://images.pexels.com/photos/11676700/pexels-photo-11676700.jpeg'
    ],
    description: 'A slim, structured portfolio for the modern professional. Fits laptops up to 14 inches, with a padded interior and hand-stitched edges.',
    details: ['Full-grain vegetable-tanned leather', 'Fits up to 14" laptop', 'Hand-stitched with waxed thread', 'Solid brass hardware', 'Interior suede lining'],
    isNew: true
  },
  {
    id: 'p002',
    name: 'Bifold Wallet — Slim',
    category: 'wallets',
    price: 3200,
    color: 'Ebony',
    image: 'https://images.pexels.com/photos/4452393/pexels-photo-4452393.jpeg',
    images: ['https://images.pexels.com/photos/4452393/pexels-photo-4452393.jpeg'],
    description: 'A minimal bifold, cut and folded from a single piece of full-grain leather. Six card slots, one note compartment.',
    details: ['Single-piece construction', '6 card slots + note compartment', 'Ages beautifully with use']
  },
  {
    id: 'p003',
    name: 'Desk Coaster — Set of Four',
    category: 'desk',
    price: 1800,
    color: 'Tan',
    image: 'https://images.pexels.com/photos/28086429/pexels-photo-28086429.jpeg',
    images: ['https://images.pexels.com/photos/28086429/pexels-photo-28086429.jpeg'],
    description: 'Round leather coasters, edge-finished by hand. Presented in a matching leather sleeve.',
    details: ['Set of four, 4" diameter', 'Hand-burnished edges', 'Comes in leather sleeve']
  },
  {
    id: 'p004',
    name: 'The Studio Mouse Pad',
    category: 'desk',
    price: 2400,
    color: 'Walnut',
    image: 'https://images.pexels.com/photos/33242820/pexels-photo-33242820.jpeg',
    images: ['https://images.pexels.com/photos/33242820/pexels-photo-33242820.jpeg'],
    description: 'A generous 30 × 22 cm leather mouse pad with a smooth top face and a felted base.',
    isNew: true,
    details: ['30 × 22 cm', 'Felted underside', 'Smooth polished top']
  },
  {
    id: 'p005',
    name: 'Tissue Box Cover',
    category: 'desk',
    price: 4600,
    color: 'Chestnut',
    image: 'https://images.pexels.com/photos/28028334/pexels-photo-28028334.jpeg',
    images: ['https://images.pexels.com/photos/28028334/pexels-photo-28028334.jpeg'],
    description: 'A tailored leather sleeve for a standard tissue box. Fits both cube and rectangular boxes.',
    details: ['Two size options', 'Magnetic closure base', 'Hand-stitched corners']
  },
  {
    id: 'p006',
    name: 'Traveller Journal — A5',
    category: 'small-leather',
    price: 3800,
    color: 'Forest',
    image: 'https://images.unsplash.com/photo-1473188588951-666fce8e7c68',
    images: ['https://images.unsplash.com/photo-1473188588951-666fce8e7c68'],
    description: 'A refillable leather journal with 160 pages of cotton paper and a soft, foldable cover.',
    details: ['160 cotton pages', 'Refillable insert', 'Elastic closure']
  },
  {
    id: 'p007',
    name: 'Keyring — Trio',
    category: 'small-leather',
    price: 1200,
    color: 'Sand',
    image: 'https://images.pexels.com/photos/4452399/pexels-photo-4452399.jpeg',
    images: ['https://images.pexels.com/photos/4452399/pexels-photo-4452399.jpeg'],
    description: 'A palm-sized loop that holds three keys with quiet confidence.',
    details: ['Solid brass ring', 'Riveted loop', 'Available in six colours']
  },
  {
    id: 'p008',
    name: 'Slim Cardholder',
    category: 'wallets',
    price: 1900,
    color: 'Ink',
    image: 'https://images.pexels.com/photos/27467355/pexels-photo-27467355.jpeg',
    images: ['https://images.pexels.com/photos/27467355/pexels-photo-27467355.jpeg'],
    description: 'Four card slots, no folds, no fuss. Slips into a shirt pocket.',
    details: ['4 card slots', 'Single-piece leather', 'Made to age']
  },
  {
    id: 'p009',
    name: 'The Everyday Belt',
    category: 'belts',
    price: 4200,
    color: 'Cognac',
    image: 'https://images.pexels.com/photos/27467423/pexels-photo-27467423.jpeg',
    images: ['https://images.pexels.com/photos/27467423/pexels-photo-27467423.jpeg'],
    description: 'A 32 mm dress belt with a solid brass buckle. Hand-cut to your size.',
    details: ['32 mm width', 'Solid brass buckle', 'Made-to-measure sizing']
  },
  {
    id: 'p010',
    name: 'The Weekend Tote',
    category: 'bags',
    price: 18400,
    color: 'Chocolate',
    image: 'https://images.unsplash.com/photo-1517612228538-cefdbc2c01e7',
    images: ['https://images.unsplash.com/photo-1517612228538-cefdbc2c01e7'],
    description: 'An unstructured tote that softens with time. Roomy enough for a weekend away.',
    isNew: true,
    details: ['Unlined interior', 'Rolled leather handles', 'One interior pocket']
  },
  {
    id: 'p011',
    name: 'Gift Set — The Desk Trio',
    category: 'gifting',
    price: 6800,
    color: 'Assorted',
    image: 'https://images.pexels.com/photos/28028334/pexels-photo-28028334.jpeg',
    images: ['https://images.pexels.com/photos/28028334/pexels-photo-28028334.jpeg'],
    description: 'A curated set: mouse pad, four coasters and a slim cardholder, presented in a cotton dust bag.',
    details: ['Mouse pad + coasters + cardholder', 'Cotton dust bag', 'Gift-ready']
  },
  {
    id: 'p012',
    name: 'Passport Sleeve',
    category: 'small-leather',
    price: 2200,
    color: 'Oxblood',
    image: 'https://images.pexels.com/photos/27467423/pexels-photo-27467423.jpeg',
    images: ['https://images.pexels.com/photos/27467423/pexels-photo-27467423.jpeg'],
    description: 'A close-fitting sleeve for one passport, cut to slide comfortably in and out.',
    details: ['Fits standard passports', 'Two internal card slots', 'Debossed monogram option']
  }
];

export const editorialStories = [
  {
    id: 's1',
    kicker: 'The Journal',
    title: 'On patience, and the making of a good belt',
    excerpt: 'A single belt passes through eleven pairs of hands before it leaves our workshop. We follow one, from hide to buckle.',
    image: 'https://images.pexels.com/photos/11676700/pexels-photo-11676700.jpeg'
  },
  {
    id: 's2',
    kicker: 'Craftsmanship',
    title: 'Why we still stitch by hand',
    excerpt: 'A saddle-stitched seam takes eight times longer than a machined one. It also outlasts it by decades.',
    image: 'https://images.pexels.com/photos/4452610/pexels-photo-4452610.jpeg'
  },
  {
    id: 's3',
    kicker: 'The House',
    title: 'A visit to the workshop in Surat',
    excerpt: 'Where our leather is chosen, cut, edged and finished — always by the same small team.',
    image: 'https://images.pexels.com/photos/4452399/pexels-photo-4452399.jpeg'
  }
];

export const testimonials = [
  { id: 't1', quote: 'My laptop portfolio has aged into something better than the day it arrived.', author: 'A. Mehra', city: 'Bengaluru' },
  { id: 't2', quote: 'The desk set changed the tone of my workspace entirely.', author: 'S. Iyer', city: 'Mumbai' },
  { id: 't3', quote: 'Quietly beautiful. That is the phrase.', author: 'R. Kapoor', city: 'Delhi' }
];

export const formatPrice = (n) => `\u20B9${n.toLocaleString('en-IN')}`;
